export default function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime-corejs2/helpers/esm/assertThisInitialized.js
// module id = null
// module chunks = 